// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// the filter at the top of the page
export const AFS_GRID_FILTER = 'afs-grid-filter'

// the table which shows all the AFS results.
export const AFS_GRID_RESULTS = 'afs-grid-results'

// the table which shows all the AFS results.
export const AFS_IGNORE_PATHS_LOOKUP = 'afs-ignore-paths-lookup'

// the full page form which shows all the AFS Results Filter options.
export const AFS_RESULTS_FILTER = 'afs-results-filter'

// the parameters form which configures analysis settings
export const AFS_PARAMETERS = 'afs-parameters'

export const AFS_CASE_SUMMARY_WRAPPER = 'afs-case-summary-wrapper'

export const CASE_DETAILS_ANTENNA_UPDATE_FORM = 'case-details-antenna-update-form'

export const EARTH_STATION_RESULTS_FORM = 'EARTH_STATION_RESULTS_FORM'
